import type { LogoProps } from "components/Logo";
import { Logo } from "components/Logo";
import type { ReactStoryblokComponent } from "types/storyblok";

const LogoAdapter = ({ blok: { logo, logoWidth, color }, sbEditable }: ReactStoryblokComponent<LogoProps>) => (
  <Logo logo={logo} logoWidth={logoWidth} color={color} sbEditable={sbEditable} />
);

export default LogoAdapter;
